import { MAX_NUM_OF_PLAYERS } from '@/helpers/constantsNew'
import {
  rangesDataSkeleton,
  getAvailableActionsFromApiSolutions,
  getHspotFromApisolutions,
  getSolProps,
  toggleSolProps,
} from '@/helpers/solution'
import { solutionStore } from '@gto/gw-store'

function getInitialState() {
  const res = {
    updated: 0,
    solution_picked: [],
    hSpot: {},
  }
  return res
}

const { combos: ii_combos, tableGroups: ii_tableGroups } = rangesDataSkeleton()

const ske_tableGroups = ii_tableGroups
const ske_combos = ii_combos

let gw_combos = ii_combos
let gw_tableGroups = ii_tableGroups

let gw_players = Array.from({ length: MAX_NUM_OF_PLAYERS }, () => ({}))
let gw_solData = {}
let gw_solution = []
let gw_catDraws = []
let gw_catHands = []
let gw_catEqBuckets = []
let gw_catEqBucketsAdvanced = []

const getters = {
  ske_tableGroups: (state, getters) => () => ske_tableGroups,
  ske_combos: (state, getters) => () => ske_combos,

  sol_data_updated: state => state.updated,
  sol_data_hSpot: state => state.hSpot,
  sol_data_street: state => state.hSpot.street || 'preflop',
  sol_data_solution_picked: state => state.solution_picked,

  // non reactive
  sol_data_tableGroups: (state, getters) => () => gw_tableGroups,
  sol_data_combos: (state, getters) => () => gw_combos,

  sol_data_players: state => () => gw_players,
  sol_data_solData: state => () => gw_solData,
  sol_data_catDraws: state => () => gw_catDraws,
  sol_data_catHands: state => () => gw_catHands,
  sol_data_catEqBuckets: state => () => gw_catEqBuckets,
  sol_data_catEqBucketsAdvanced: state => () => gw_catEqBucketsAdvanced,
  sol_data_solution: state => () => gw_solution,
}

const actions = {
  sol_data_handleApiCall({ state, commit, dispatch, getters }, result) {
    if (result?.response?.status !== 200 || !result.response?.data) {
      return
    }

    // this whole refreshing a knowing whenether elite is elite, has history and soon
    // definitelly needs some revision too many edge cases it seems (many of them can happen only once)
    const { params } = result

    if (params.custom_solution_id && !getters.sol_elite.has_history) {
      // this should happen only once when user visited 200 elite solution
      // for the first time so he has no history yet
      // next time the initital call should refurn min 1 record so this if wont go through
      // cos the elite solution will be already created
      // (history is recorded only after succesfull /solution call with custom_solution_id)
      // so this one time refresh info about custom solution history
      // debugger
      dispatch('api_poker_custom_solution_history_initial')
    }

    solutionStore
      .getState()
      .setSolutionApiResponse(params.custom_solution_id, result.response?.data)

    const apiData = result.response?.data
    dispatch('sol_data_initialize', { apiData })
  },
  sol_data_initialize({ state, commit, dispatch, getters, rootGetters }, { apiData }) {
    // NON_ZERO_EV_FOLD, ZERO_RANGE, EVS_FREQUENCIES_MISMATCH, NEGATIVE_EV
    if (apiData.warning) {
      dispatch('messages_custom', { id: 'message_zero_frequency_line' })
    }

    dispatch('sol_data_setSolProps', { apiData })

    if (rootGetters.keepFiltersBetweenSpots) {
      dispatch('sol_filters_cleanup', {
        actions: state.solution_picked,
        allCategories: {
          hand_categories: gw_catHands, //
          draw_categories: gw_catDraws,
          equity_buckets: gw_catEqBuckets,
          equity_buckets_advanced: gw_catEqBucketsAdvanced,
        },
      })
    } else {
      dispatch('sol_filters_reset')
    }

    dispatch('sol_detail_initialize', { tableGroups: gw_tableGroups })
  },
  sol_data_setSolProps({ state, commit, dispatch, getters }, { apiData }) {
    if (!apiData?.players_info) {
      return
    }
    const {
      evProps,
      solution_picked,
      solData,
      solution,
      tableGroups,
      combos,
      players,
      catDraws,
      catHands,
      catEqBuckets,
      catEqBucketsAdvanced,
    } = getSolProps({
      apiData,
      combos: gw_combos,
      handsIsometric: null,
      tableGroups: gw_tableGroups,
    })
    const available_actions = getAvailableActionsFromApiSolutions({ solData })
    const hSpot = getHspotFromApisolutions({ game: solData.game, available_actions })

    state.hSpot = hSpot
    state.solution_picked = solution_picked
    state.evProps = evProps
    gw_solData = solData
    gw_solution = solution
    gw_tableGroups = tableGroups
    gw_combos = combos
    gw_players = players
    gw_catHands = catHands
    gw_catDraws = catDraws
    gw_catEqBuckets = catEqBuckets
    gw_catEqBucketsAdvanced = catEqBucketsAdvanced
    state.updated = Date.now()
  },
  sol_data_applyFilter({ state, commit, dispatch, getters, rootGetters }, result) {
    const { solution_picked, combos, tableGroups, playersSelectedCombosIds, playersTotalRange } =
      toggleSolProps({
        filter: getters.sol_filter_combos,
        solution: gw_solution,
        combos: gw_combos,
        tableGroups: gw_tableGroups,
      })

    state.solution_picked = solution_picked
    gw_combos = combos
    gw_tableGroups = tableGroups

    state.updated = Date.now()

    // Update players total range filtered
    gw_players?.forEach((player, index) => {
      player.total_range_filtered = playersTotalRange[index]
    })
    commit('sol_filters_set', { key: 'hands_players', value: playersSelectedCombosIds })
  },
}

const mutations = {
  sol_data_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
